
// city menu

// Cityes
const cityLinks = document.querySelectorAll('.aside-menu-city');
const districtLinks = document.querySelectorAll('.aside-menu-district');

function hideCityContent() {
  const citesContent = document.querySelectorAll('[data-city]');
  citesContent.forEach(e => {
    e.classList.add('is-hidden');
  });
  cityLinks.forEach(e => {
    e.classList.remove('is-active');
  });
  districtLinks.forEach(e => {
    e.classList.remove('is-active');
  });
}

function hideDistrictContent() {
  const elements = document.querySelectorAll('[data-district]');
  elements.forEach(e => {
    e.classList.add('is-hidden');
  });
  districtLinks.forEach(e => {
    e.classList.remove('is-active');
  });
  cityLinks.forEach(e => {
    e.classList.remove('is-active');
  });
}

function showCity(city) {
  hideCityContent();
  const cityContent = document.querySelector(`[data-city="${city}"]`);
  const cityLink = document.querySelector(`.aside-menu-city.${city}`);
  const allDistricts = document.querySelectorAll('[data-district]');
  allDistricts.forEach(e => {
    e.classList.remove('is-hidden');
  });

  cityContent.classList.remove('is-hidden');
  cityLink.classList.add('is-active');
}

function showDistrict(district) {
  hideDistrictContent();
  const districtContent = document.querySelector(`[data-district="${district}"]`);
  const districtLink = document.querySelector(`.aside-menu-district.${district}`);
  districtContent.classList.remove('is-hidden');
  districtLink.classList.add('is-active');
}

// Tbulisi
const tbilisiLink = document.querySelector('.aside-menu-city.tbilisi');
if (!!tbilisiLink) {
  tbilisiLink.addEventListener('click', () => {
    showCity('tbilisi');
  });
}

// Batumi
const batumiLink = document.querySelector('.aside-menu-city.batumi');
if (!!batumiLink) {
  batumiLink.addEventListener('click', () => {
    showCity('batumi');
  });
}

// Districts
// Collapse button for districts
var btn = document.querySelector(".collaps-btn");
var container = document.querySelector(".dist-content");
var default_height = container.style.maxHeight;

container.style.maxHeight = default_height;

btn.addEventListener("click", function() {
  if (container.style.maxHeight !== default_height) {
    container.style.maxHeight = default_height;
    btn.innerHTML = 'Развернуть';
  } else {
    container.style.maxHeight = container.scrollHeight + "px";
    btn.innerHTML = 'Свернуть';
  }
});

// Avlabari
const avlabariLink = document.querySelector('.aside-menu-district.avlabary');
if (!!avlabariLink) {
  avlabariLink.addEventListener('click', () => {
    showCity('tbilisi');
    showDistrict('avlabary');
  });
}

// Abanotybany
const abanotybanyLink = document.querySelector('.aside-menu-district.abanotybany');
if (!!avlabariLink) {
  abanotybanyLink.addEventListener('click', () => {
    showCity('tbilisi');
    showDistrict('abanotybany');
  });
}

// Bagebi
const bagebiLink = document.querySelector('.aside-menu-district.bagebi');
if (!!bagebiLink) {
  bagebiLink.addEventListener('click', () => {
    showCity('tbilisi');
    showDistrict('bagebi');
  });
}

// Vake
const vakeLink = document.querySelector('.aside-menu-district.vake');
if (!!vakeLink) {
  vakeLink.addEventListener('click', () => {
    showCity('tbilisi');
    showDistrict('vake');
  });
}

// varketili
const varketiliLink = document.querySelector('.aside-menu-district.varketili');
if (!!varketiliLink) {
  varketiliLink.addEventListener('click', () => {
    showCity('tbilisi');
    showDistrict('varketili');
  });
}

// vera
const veraLink = document.querySelector('.aside-menu-district.vera');
if (!!veraLink) {
  veraLink.addEventListener('click', () => {
    showCity('tbilisi');
    showDistrict('vera');
  });
}

// gldani
const gldaniLink = document.querySelector('.aside-menu-district.gldani');
if (!!gldaniLink) {
  gldaniLink.addEventListener('click', () => {
    showCity('tbilisi');
    showDistrict('gldani');
  });
}

// Didi Digomi
const didiDigomiLink = document.querySelector('.aside-menu-district.didi-digomi');
if (!!didiDigomiLink) {
  didiDigomiLink.addEventListener('click', () => {
    showCity('tbilisi');
    showDistrict('didi-digomi');
  });
}

// Digomi
const digomiLink = document.querySelector('.aside-menu-district.digomi');
if (!!digomiLink) {
  digomiLink.addEventListener('click', () => {
    showCity('tbilisi');
    showDistrict('digomi');
  });
}

// isani
const isaniLink = document.querySelector('.aside-menu-district.isani');
if (!!isaniLink) {
  isaniLink.addEventListener('click', () => {
    showCity('tbilisi');
    showDistrict('isani');
  });
}

// Kiketi
const kiketiLink = document.querySelector('.aside-menu-district.kiketi');
if (!!kiketiLink) {
  kiketiLink.addEventListener('click', () => {
    showCity('tbilisi');
    showDistrict('kiketi');
  });
}

// Lisi
const lisiLink = document.querySelector('.aside-menu-district.lisi');
if (!!lisiLink) {
  lisiLink.addEventListener('click', () => {
    showCity('tbilisi');
    showDistrict('lisi');
  });
}

// nadzaladevi
const nadzaladeviLink = document.querySelector('.aside-menu-district.nadzaladevi');
if (!!nadzaladeviLink) {
  nadzaladeviLink.addEventListener('click', () => {
    showCity('tbilisi');
    showDistrict('nadzaladevi');
  });
}

// Ortachala
const ortachalaLink = document.querySelector('.aside-menu-district.ortachala');
if (!!ortachalaLink) {
  ortachalaLink.addEventListener('click', () => {
    showCity('tbilisi');
    showDistrict('ortachala');
  });
}

// sabyrtalo
const saburtaloLink = document.querySelector('.aside-menu-district.sabyrtalo');
if (!!saburtaloLink) {
  saburtaloLink.addEventListener('click', () => {
    showCity('tbilisi');
    showDistrict('sabyrtalo');
  });
}

// sanzona
const sanzonaLink = document.querySelector('.aside-menu-district.sanzona');
if (!!sanzonaLink) {
  sanzonaLink.addEventListener('click', () => {
    showCity('tbilisi');
    showDistrict('sanzona');
  });
}

// chigureti
const chuguretiLink = document.querySelector('.aside-menu-district.chigureti');
if (!!chuguretiLink) {
  chuguretiLink.addEventListener('click', () => {
    showCity('tbilisi');
    showDistrict('chigureti');
  });
}

// Setup City
showCity('tbilisi');

